module.exports = __webpack_public_path__ + "static/media/zed-conomy-update.3f71ba50.png";